export default function downloadAndPackImages(
  filename = '',
  files = [],
  onEveryFileCallback = null,
  onFinishCallback = null
) {
  import('@aytm/app/stats/page/comments/lib/download/runtime').then(module => {
    module.download(filename, files, onEveryFileCallback, onFinishCallback)
  })
}
